import React from "react";
import "./RadioCustom.scss";
import { Form, Radio } from "antd";

const RadioCustom: React.FC<any> = ({ dir = 'left', hint, headingleft, className, name, rules, options, value, onChange = () =>{}}) => {
    return (
        <div className={`${className ? `${className} custom-class` : 'mb-3'} normal`}>
            <div className='inputField__error d-flex flex-column'>
                <div className="d-flex align-items-center">
                    <div className="radio-container">
                        <Form.Item
                            name={name}
                            rules={rules}
                            label={headingleft}
                            labelCol={{ span: 24, style: { textAlign: dir } }}
                            hasFeedback
                        >
                            <Radio.Group value={value} size="large" onChange={onChange} className={dir==='left' ? '' : 'dir-rtl'}>
                                {options.map((op: any, index: any)=>{
                                    return <Radio.Button value={op.value} key={op.value} className={(dir==='left' && index === 0) || (dir==='right' && index === 1) ? 'me-0' : 'ms-0'}>{op.label}</Radio.Button>
                                })}
                            </Radio.Group>
                        </Form.Item>
                    </div>
                    {hint ? <div className='hint-tooltip' data-tooltip={hint} /> : <div className="gap-18"></div>}
                </div>
            </div>
        </div>
    )
}

export default RadioCustom;
